import { Signal } from "@/constants/signal/signal"

export const WHAT_YOU_CAN_EXPECT_JOURNEY_PHASES = [
  {
    id: "before_signing",
    label: "Before you sign",
    question: "Will they be honest during sales?",
    signals: [Signal.SALES_CONDUCT],
  },
  {
    id: "during_project",
    label: "During the project",
    question: "Will the work be done well, on time?",
    signals: [Signal.WORKMANSHIP, Signal.PROJECT_MANAGEMENT],
  },
  {
    id: "after_done",
    label: "After it's done",
    question: "Will they support you long-term?",
    signals: [Signal.POST_SALE_SUPPORT, Signal.VALUE],
  },
] as const
